<template>
  <div class="follow-card">
    <div class="follow-header">
      <div class="player-avatar">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </div>
      <div class="player-info">
        <span class="player-uuid">{{ maskedUUID }}</span>
        <span class="bet-info">最近 {{ follow.bets?.length || 0 }} 筆投注</span>
      </div>
    </div>
    
    <div class="follow-bets" v-if="groupedBets.length > 0">
      <div v-for="group in groupedBets" :key="group.analysis_id" class="follow-match-block">
        <div class="match-info">
          <div class="league-tag">{{ group.match.league }}</div>
          <div class="teams-line">
             <span class="team-name">{{ group.match.home_team.name }}</span>
             <span class="match-score" v-if="group.match.full_score">{{ group.match.full_score }}</span>
             <span class="vs-label" v-else>VS</span>
             <span class="team-name">{{ group.match.away_team.name }}</span>
          </div>
        </div>

        <div class="match-markets">
          <!-- AH -->
          <div class="market-section">
            <div class="market-title">讓球盤 ({{ formatHandicap(group.match.first_odds ? group.match.first_odds.handicap_line : null) }})</div>
            <div class="odds-row odds-row--2">
              <div class="btn-odd read-only" :class="{ active: isSelected(group.bets, 'AH', 'HOME'), ...getStatusClass(group.bets, 'AH', 'HOME') }">
                <span class="odd-label">主隊</span>
                <span v-if="isSelected(group.bets, 'AH', 'HOME') && getPayout(group.bets, 'AH', 'HOME') !== null" class="payout">{{ getPayout(group.bets, 'AH', 'HOME') }}</span>
                <span class="odd-val">{{ fmt(group.match.first_odds ? group.match.first_odds.handicap_home : null) }}</span>
              </div>
              <div class="btn-odd read-only" :class="{ active: isSelected(group.bets, 'AH', 'AWAY'), ...getStatusClass(group.bets, 'AH', 'AWAY') }">
                <span class="odd-label">客隊</span>
                <span v-if="isSelected(group.bets, 'AH', 'AWAY') && getPayout(group.bets, 'AH', 'AWAY') !== null" class="payout">{{ getPayout(group.bets, 'AH', 'AWAY') }}</span>
                <span class="odd-val">{{ fmt(group.match.first_odds ? group.match.first_odds.handicap_away : null) }}</span>
              </div>
            </div>
          </div>

          <!-- 1X2 -->
          <div class="market-section">
            <div class="market-title">標準盤 (1X2)</div>
            <div class="odds-row odds-row--3">
              <div class="btn-odd read-only" :class="{ active: isSelected(group.bets, '1X2', 'HOME'), ...getStatusClass(group.bets, '1X2', 'HOME') }">
                <span class="odd-label">主勝</span>
                <span v-if="isSelected(group.bets, '1X2', 'HOME') && getPayout(group.bets, '1X2', 'HOME') !== null" class="payout">{{ getPayout(group.bets, '1X2', 'HOME') }}</span>
                <span class="odd-val">{{ fmt(group.match.first_odds ? group.match.first_odds.odds_home_win : null) }}</span>
              </div>
              <div class="btn-odd read-only" :class="{ active: isSelected(group.bets, '1X2', 'DRAW'), ...getStatusClass(group.bets, '1X2', 'DRAW') }">
                <span class="odd-label">和局</span>
                <span v-if="isSelected(group.bets, '1X2', 'DRAW') && getPayout(group.bets, '1X2', 'DRAW') !== null" class="payout">{{ getPayout(group.bets, '1X2', 'DRAW') }}</span>
                <span class="odd-val">{{ fmt(group.match.first_odds ? group.match.first_odds.odds_draw : null) }}</span>
              </div>
              <div class="btn-odd read-only" :class="{ active: isSelected(group.bets, '1X2', 'AWAY'), ...getStatusClass(group.bets, '1X2', 'AWAY') }">
                <span class="odd-label">客勝</span>
                <span v-if="isSelected(group.bets, '1X2', 'AWAY') && getPayout(group.bets, '1X2', 'AWAY') !== null" class="payout">{{ getPayout(group.bets, '1X2', 'AWAY') }}</span>
                <span class="odd-val">{{ fmt(group.match.first_odds ? group.match.first_odds.odds_away_win : null) }}</span>
              </div>
            </div>
          </div>

          <!-- OU -->
          <div class="market-section">
            <div class="market-title">大小球 ({{ formatGoalsLine(group.match.first_odds ? group.match.first_odds.goals_line : null) }})</div>
            <div class="odds-row odds-row--2">
              <div class="btn-odd read-only" :class="{ active: isSelected(group.bets, 'OU', 'OVER'), ...getStatusClass(group.bets, 'OU', 'OVER') }">
                <span class="odd-label">大球</span>
                <span v-if="isSelected(group.bets, 'OU', 'OVER') && getPayout(group.bets, 'OU', 'OVER') !== null" class="payout">{{ getPayout(group.bets, 'OU', 'OVER') }}</span>
                <span class="odd-val">{{ fmt(group.match.first_odds ? group.match.first_odds.goals_over : null) }}</span>
              </div>
              <div class="btn-odd read-only" :class="{ active: isSelected(group.bets, 'OU', 'UNDER'), ...getStatusClass(group.bets, 'OU', 'UNDER') }">
                <span class="odd-label">小球</span>
                <span v-if="isSelected(group.bets, 'OU', 'UNDER') && getPayout(group.bets, 'OU', 'UNDER') !== null" class="payout">{{ getPayout(group.bets, 'OU', 'UNDER') }}</span>
                <span class="odd-val">{{ fmt(group.match.first_odds ? group.match.first_odds.goals_under : null) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-bets" v-else>
      暫無投注紀錄
    </div>
  </div>
</template>

<script>
import { formatHandicap, formatGoalsLine } from '@/utils/odds'

export default {
  name: 'FollowCard',
  props: {
    follow: { type: Object, required: true }
  },
  computed: {
    maskedUUID() {
      // Use masked uuid from backend if available, fallback to #id
      if (this.follow.uuid) return this.follow.uuid
      const uid = this.follow.followed_user_id
      return uid ? `#${uid}` : '---'
    },
    groupedBets() {
      const bets = this.follow.bets || []
      const groups = {}
      bets.forEach(b => {
        if (!groups[b.analysis_id]) {
          groups[b.analysis_id] = {
            analysis_id: b.analysis_id,
            match: b.match,
            bets: []
          }
        }
        groups[b.analysis_id].bets.push(b)
      })
      return Object.values(groups).sort((a,b) => {
        return (b.match.match_date || "").localeCompare(a.match.match_date || "")
      })
    }
  },
  methods: {
    isSelected(bets, marketId, selectionId) {
      return bets.some(b => b && b.market_id === marketId && b.selection_id === selectionId)
    },
    getBet(bets, marketId, selectionId) {
      return bets.find(b => b && b.market_id === marketId && b.selection_id === selectionId)
    },
    getPayout(bets, marketId, selectionId) {
      const b = this.getBet(bets, marketId, selectionId)
      return b ? b.payout : null
    },
    getStatusClass(bets, marketId, selectionId) {
      const b = this.getBet(bets, marketId, selectionId)
      if (!b || b.status === 'PENDING') return {}
      return {
        [`status--${b.status.toLowerCase()}`]: true
      }
    },
    fmt(val) {
      if (val === null || val === undefined) return '—'
      const n = Number(val)
      if (isNaN(n)) return val
      return n % 1 === 0 ? String(n) : n.toFixed(2).replace(/0+$/, '')
    },
    formatHandicap,
    formatGoalsLine
  }
}
</script>

<style scoped>
.follow-card {
  background: var(--bg-card);
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
}

.follow-card:last-child {
  border-bottom: none;
}

.follow-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
}

.player-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary) 0%, #8A2BE2 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.player-avatar svg {
  width: 20px;
  height: 20px;
}

.player-info {
  display: flex;
  flex-direction: column;
}

.player-uuid {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.bet-info {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
}

.follow-bets {
  padding-right: 0;
}

.follow-match-block {
  background: var(--bg-body);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 16px;
  border: 1px solid var(--border);
}

.match-info {
  text-align: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px dashed var(--border);
}

.league-tag {
  font-size: 11px;
  color: var(--primary-light);
  font-weight: 700;
  margin-bottom: 4px;
}

.teams-line {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.team-name {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
}

.match-score {
  font-weight: 800;
  color: var(--score-full);
  font-size: 14px;
}

.vs-label {
  font-size: 11px;
  color: var(--text-muted);
  font-weight: 800;
}

.market-section {
  margin-bottom: 12px;
}
.market-title {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 6px;
  font-weight: 600;
  text-align: center;
}
.odds-row {
  display: grid;
  gap: 6px;
}
.odds-row--2 { grid-template-columns: 1fr 1fr; }
.odds-row--3 { grid-template-columns: 1fr 1fr 1fr; }

.btn-odd {
  background: var(--bg-overlay);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-primary);
  position: relative;
  overflow: hidden;
}

.btn-odd.read-only {
  cursor: default;
}

.btn-odd.active {
  background: #FF8C00;
  border-color: #FF8C00;
  color: #fff;
}

.btn-odd.active .odd-label, .btn-odd.active .odd-val {
  color: #fff;
}

/* Status colors */
.status--win.active { background-color: var(--score-full); border-color: var(--score-full); }
.status--lose.active { background-color: #E53935; border-color: #E53935; }
.status--void.active { background-color: var(--text-muted); border-color: var(--text-muted); }

.odd-label { font-size: 11px; color: var(--text-muted); }
.odd-val { font-size: 12px; font-weight: 700; font-variant-numeric: tabular-nums; }



.payout {
  font-size: 11px;
  font-weight: 800;
  background: rgba(0,0,0,0.2);
  padding: 0 4px;
  border-radius: 3px;
}

.empty-bets {
  text-align: center;
  padding: 24px;
  color: var(--text-muted);
  font-size: 14px;
  background: var(--bg-body);
  border-radius: 8px;
}
</style>
